import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BookOpen, Download, Eye, Loader2, Presentation } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOPICS = ['Bu Sürümde Yenilikler', 'Kayıt ve Firma Onayı', 'Personel ve Belgeler', 'Çalışma İzni Talebi Oluşturma', 'Animasyonlu Rehberler', 'Talep Durumları ve Eksik Düzeltme', 'Onay, QR ve Kopyalama', 'Duyurular, Dokümanlar ve Five Star', 'Sağlık Raporu Maskeleme', 'Kendi Menünüzü Oluşturun', 'Firma Erişimi: İSG\'den Uzaktan Destek', 'Mobil Uyum ve PWA', 'Güvenlik ve KVKK', 'İpuçları'];

// Firma yetkilisi: kendi adımlarını anlatan kısa kılavuz PDF'i
export default function FirmGuidePage() {
  const [busy, setBusy] = useState(false);
  const get = async (download, fmt = 'pdf') => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/firm/user-guide/${fmt}`, { responseType: 'blob' });
      const href = URL.createObjectURL(r.data);
      if (!download) window.open(href, '_blank');
      else { const a = document.createElement('a'); a.href = href; a.download = `Firma_Kullanim_Kilavuzu.${fmt}`; a.click(); }
    } catch { toast.error('Kılavuz açılamadı'); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-3xl space-y-6" data-testid="firm-guide-page">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900"><BookOpen className="h-6 w-6 text-orange-500" />Kullanım Kılavuzu</h1>
        <p className="text-sm text-slate-500">Kayıttan çalışma izni onayına kadar tüm adımları ekran görüntüleriyle anlatan kısa rehber.</p>
      </div>
      <div className="flex gap-3">
        <Button onClick={() => get(true)} disabled={busy} className="bg-orange-500 hover:bg-orange-600" data-testid="firm-guide-download">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Download className="mr-2 h-4 w-4" />}PDF İndir</Button>
        <Button variant="outline" onClick={() => get(true, 'pptx')} disabled={busy} data-testid="firm-guide-pptx"><Presentation className="mr-2 h-4 w-4" />PowerPoint İndir</Button>
        <Button variant="outline" onClick={() => get(false)} disabled={busy} data-testid="firm-guide-view"><Eye className="mr-2 h-4 w-4" />Görüntüle</Button>
      </div>
      <div className="rounded-xl border bg-white p-5">
        <p className="mb-3 text-sm font-semibold text-slate-800">Konular</p>
        <ol className="space-y-1.5 text-sm text-slate-600">{TOPICS.map((t, i) => <li key={t} className="flex gap-2"><span className="font-mono font-bold text-orange-500">{i + 1}.</span>{t}</li>)}</ol>
      </div>
    </div>
  );
}
